import { addCommas } from '@shared/utility-functions';

let userCount;
let userCountSpeed;
let projectCount;
let projectCountSpeed;
const userElements = [];
const projectElements = [];

// Create a new promise to check for the AJAX call to get the site stats info.
const initPromise = new Promise((resolve, reject) => {
  fetch('/ajax/_general_vars.php', {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }

      const error = new Error(response.statusText);
      error.response = response;
      reject(error);
    })
    .then(json => {
      resolve(json);
    });
});

// Create another promise to check for the incrementer settings to increment
// the site stats periodically.
const incrementerPromise = new Promise((resolve, reject) => {
  fetch('/ajax/count-24h.php', {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }

      const error = new Error(response.statusText);
      error.response = response;
      reject(error);
    })
    .then(json => {
      resolve(json);
    });
});

// Get both promises and wait until both are finished, then initialise the
// site stats.
Promise.all([initPromise, incrementerPromise])
  .then(values => {
    userCountSpeed = 86400000 / values[1].user_count_24h;
    userCount = parseInt(values[0].user_count, 10);

    projectCountSpeed = 86400000 / values[1].project_count_24h;
    projectCount = parseInt(values[0].project_count, 10);

    updateElements(userElements, userCount, userCountSpeed);
    updateElements(projectElements, projectCount, projectCountSpeed);
  })
  .catch(error => {
    throw error;
  });

function updateElements(elements, currentCount, speed) {
  const processStatsUpdate = () => {
    elements.map(element => {
      element.textContent = addCommas(currentCount);
      return element;
    });
    currentCount = parseInt(currentCount, 10) + 1;
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(processStatsUpdate, { timeout: 30000 });
  } else {
    processStatsUpdate();
  }

  setTimeout(() => updateElements(elements, currentCount, speed), speed);
}

export function updateUserCount(element) {
  userElements.push(element);
}

export function updateProjectCount(element) {
  projectElements.push(element);
}
